export default (that) => [
  {
    field: 'seq',
    width: 50,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    title: that.$l('INDEX.table_label_operation') || '操作',
    field: 'col-opt',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_proofingNo') || '打样单号',
    field: 'proofingNo',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_proofingStatus') || '执行状态',
    field: 'proofingStatus',
    minWidth: 125,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'proofingStatus' },
  },
  {
    title: that.$l('table_label_requestDate') || '下单日期',
    field: 'requestDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_finishDate') || '要求完成日期',
    field: 'finishDate',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_cust') || '客户',
    field: 'custName',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_scm') || '打样工厂',
    field: 'scmName',
    minWidth: 200,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_salesPerson') || '业务人员',
    field: 'salesPersonName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_designer') || '设计师',
    field: 'designerName',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    minWidth: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
